<div>
  <app-page>
    <app-page-title [title]="'COMPLIANCE.OVERVIEW.TITLE' | translate">
      <dx-button
        class="cta-btn"
        type="normal"
        icon="add"
        [text]="'COMPLIANCE.OVERVIEW.ADD-TITLE' | translate"
        (click)="navigateToNewCompliance()"
      ></dx-button>
    </app-page-title>
    <app-table
      [data]="(allComplianceCategories$ | async) || []"
      [columns]="columns"
      [showSearch]="true"
      [searchLabel]="'COMMON.SEARCH' | translate"
      [searchPlacehoder]="'COMMON.SEARCH' | translate"
      (onRowClick)="navigateToCompliance($event)"
      [stateKey]="stateKey"
      [showFilterPanel]="true"
    ></app-table>
  </app-page>
</div>
